export function selectedPaymentKind($root, inputName) {
    const name = inputName || 'mgr_pledge_payment_method_pref';
    const checked = String($root.find(`input[name="${name}"]:checked`).val() || '').trim();
    if (checked) {
        return checked;
    }
    const hidden = String($root.find(`input[name="${name}"]`).val() || '').trim();
    return hidden || 'online';
}

export function isOnlinePaymentKind(kind) {
    return kind === 'online';
}

export function isCheckCashPaymentKind(kind) {
    return kind === 'check_cash';
}

export function isQrPaymentKind(kind) {
    return kind === 'qr';
}
